<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-figure-patterns-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-figure-patterns-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.53225806451613;"
    data-aspect-ratio="0.532"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-figure-patterns-xs-img"
      class="g-figure-patterns-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/figure-patterns-xs.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-figure-patterns-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.82258064516129;"
    data-aspect-ratio="0.823"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-figure-patterns-sm-img"
      class="g-figure-patterns-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/figure-patterns-sm.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-figure-patterns-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.53846153846154;"
    data-aspect-ratio="1.538"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-figure-patterns-md-img"
      class="g-figure-patterns-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/figure-patterns-md.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-figure-patterns-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-figure-patterns-lg-img"
      class="g-figure-patterns-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/figure-patterns-lg.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-figure-patterns-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-figure-patterns-xl-img"
      class="g-figure-patterns-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/figure-patterns-xl.jpg);"
      loading="lazy"
    ></div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-07 16:44 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-07 16:44 -->
<!-- ai file: figure-patterns.ai -->
<style lang="scss">
  #g-figure-patterns-box {
    container-type: inline-size;
    container-name: g-figure-patterns-box;
  }
  #g-figure-patterns-box,
  #g-figure-patterns-box .g-artboard {
    margin: 0 auto;
  }
  #g-figure-patterns-box p {
    margin: 0;
  }
  #g-figure-patterns-box .g-aiAbs {
    position: absolute;
  }
  #g-figure-patterns-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-figure-patterns-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-figure-patterns-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-figure-patterns-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-figure-patterns-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-figure-patterns-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-figure-patterns-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-figure-patterns-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-figure-patterns-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-figure-patterns-xl {
        display: block !important;
      }
    }
  }
  #g-figure-patterns-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-figure-patterns-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-figure-patterns-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-figure-patterns-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-figure-patterns-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }

  /* Custom CSS */
</style>
